
export enum WaitlistManagementType {
    "Active" = "Active",
    "InActive" = "InActive"
}


export interface GetWaitlistManagementData {
    waitlists: any[];
    sortFilter: {
        year: {
            range: number[];
            default: number
        }
    }
}